import React from 'react';
import styled from "styled-components";

import playIcon from '../assets/icon-play.svg';
import studyIcon from '../assets/icon-study.svg';
import workIcon from '../assets/icon-work.svg';
import selfcareIcon from '../assets/icon-self-care.svg';
import socialIcon from '../assets/icon-social.svg';
import exerciseIcon from '../assets/icon-exercise.svg';


import {useTheme} from "../contexts/ThemeContext";

function Card(props) {

    const { isDarkTheme, toggleTheme } = useTheme();

    const setHeaderClass = (name) =>{
        return name.replace(/\s/g, "").toLowerCase()
    }

    return (
        <div>
            <ItemHeader className={ setHeaderClass(props.data.title)}></ItemHeader>
            <Item theme={isDarkTheme ? "dark":"light"}>
                    <Title>{props.data.title}</Title>
                    <Hours>{props.data.timeframes[props.view.toLowerCase()].current}hrs</Hours>
                    <div>Last week - {props.data.timeframes[props.view.toLowerCase()].previous}hrs</div>
            </Item>
        </div>
    );
}


const Item = styled.div`
  padding: 25px 40px;
  border-radius: var(--border-radius-base);
  position: relative;
  min-width:260px;

  color: ${(props) => (props.theme==='dark' ? 'white' : 'var(--tile-light-text)')};
  background-color: ${(props) => (props.theme==='dark' ? 'var(--dark-blue)' : 'var(--tile-light-bg)')};
  
  &:hover{
    color: ${(props) => (props.theme==='dark' ? 'inherit' : 'white')};
    background: ${(props) => (props.theme==='dark' ? 'var(--desaturated-blue)' : 'var(--tile-light-bg-hover)')};
   
    cursor: pointer;
  }
`
const ItemHeader = styled.div`
  border-top-left-radius:var(--border-radius-base);
  border-top-right-radius: var(--border-radius-base);
  height: 45px;
  margin-bottom: -15px;
  pointer-events: none;

  background-repeat: no-repeat;
  background-position: 90% 0px;
  background-size: 18%;


  &.work{
    background-color:var(--primary-red);
    background-image:url(${workIcon})
  }
  &.play{
    background-color:var(--soft-blue);
    background-image:url(${playIcon})
  }
  &.study{
    background-color:var(--soft-red);
    background-image:url(${studyIcon})
  }
  &.social{
    background-color:var(--primary-violet);
    background-image:url(${socialIcon})
  }
  &.exercise{
    background-color: var(--primary-lime);
    background-image:url(${exerciseIcon})
  }
  &.selfcare{
    background-color: var(--primary-orange);
    background-image:url(${selfcareIcon})
  }
`
const Title = styled.h3`
  font-weight: 400;
  font-size: 1.5rem;
`
const Hours = styled.h1`
  font-weight: 400;
  font-size: clamp(2rem, 3.5rem, 3.75rem);
`

export default Card;